module.exports = __webpack_public_path__ + "static/media/ETH.b62253a4.webp";